// extracted by mini-css-extract-plugin
module.exports = {"floatingMenuContainer":"styles_floatingMenuContainer__2sDh8","sortBy":"styles_sortBy__2JGne"};